export const MFA_ENFORCEMENT_OPTIONS = [
  "mandatory",
  "optional",
  "disabled",
];

export const MFA_METHOD_SUGGESTIONS = [
  "sms",
  "email",
  "totp",
  "push",
  "authenticator_app",
];

/** Seconds helpers for password expiry display. */
export const SECONDS_PER_DAY = 86400;
